// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customAccordionSummary {
  height: 40px;
  min-height: 0 !important; }
`, "",{"version":3,"sources":["webpack://./src/layouts/makePayment/makePayment.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,wBAAwB,EAAA","sourcesContent":[".customAccordionSummary {\n  height: 40px;\n  min-height: 0 !important;\n  //  background:aliceblue !important;/* Customize the height as per your requirement */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
